import axios from '../../common/axiosInterceptor';

interface ILChangePasswordAjaxReturn {
  /** Success if password is successfully changed */
  success: boolean;
  error?: any;
}

interface IChangePasswordAjax {
  /** Parameters to update password */
  newpass: string;
  user: string;
  signature: string;
}

/**
 *
 * @returns Success if password is successfully changed
 */
export const changePasswordAjax = async ({
  newpass,
  user,
  signature,
}: IChangePasswordAjax): Promise<ILChangePasswordAjaxReturn> => {
  try {
    const response = await axios.post(
      `${process.env.VITE_APP_API_DOMAIN}/itn/legacy/changePassword`,
      {
        call: 'changePassword',
        user: user,
        newpass: newpass,
        signature: signature,
        react: true,
      }
    );

    return response.data;
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
};
